

import React, { useState, useRef } from 'react';
import './dnd.css'
import getNodeType from './NodeTypes'; 
import recorder from '../img/recorder.png';
import loadimg from '../img/load.png';
import clouddownload from '../img/cloud-download.png';
import cloudupload from '../img/cloud-upload.png';
import getFields from './ActionFields';

import ProcessList from './ProcessList';

  import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    removeElements,
    Controls, Background
  } from 'react-flow-renderer';  

  import PDTabs from './PDTabs';

  // const initialScreenElements = [
  //   {
  //     id: '1',
  //     type: 'input',
  //     data: { label: 'ScreenFlow'},
  //     position: { x: 500, y: 50 },
  //     style: {
  //       background: 'steelblue',
  //       color: 'white',
  //       border: '1px solid #222138',
  //       width: 60,
  //     },
  //   }
  // ];



const initialElements = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Flow View' },
    position: { x: 615, y: 50 },
    style: {
      // background: 'steelblue',
      color: 'black',
      // border: '1px solid #222138',
      border: '1px solid lightgrey',
      boxShadow: '0 0 8px grey',

      // background: '#bfd6df',
      backgroundImage: 'linear-gradient(to bottom, skyblue, #bfd6df)',

      width: 200,
      fontSize: 16,
    },
  }

];



  const nodeStyle = {
    // background: '#9999ff',
    // background: '#649cdc',
    background:'white',
    color: 'white',
    border: '1px solid grey',
    // boxShadow: '0 0 3px lightgrey',
    // borderRadius: '10px',
        // width: 600,
    // height: 200,
    
  };
  

  let id = 0;
  const getId = () => `dndnode_${id++}`;

  const ProcessDiscovery = () => {

    const edgeStyle = {
      // stroke: '#9999ff',
      // stroke: 'blue',
      strokeWidth:2.0,
      // strokeOpactiy:0.1
  
    };
  
  
    var lastPosition = { x:500, y:50}

    // const [process, setProcess] = useState([])
    const [model, setModel] = useState([])
    const [entityName, setEntityName] = useState("newbot");

    const [mostTimeSpent, setMostTimeSpent] = useState(0)
    const [mostTimeSpentApp, setMostTimeSpentApp] = useState('')

    const [appHops, setAppHops] = useState(0)

    const [appTimeMap, setAppTimeApp] = useState(new Map())

    const [selectedElement, setSelectedElement] = useState(null)

    const [fromElement, setFromElement] = useState(1)
    const [appFromElement, setAppFromElement] = useState(null)
    const [toElement, setToElement] = useState(2)


    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const [elements, setElements] = useState(initialElements);
    const [appElements, setAppElements] = useState([]);

    const [totalTime, setTotalTime] = useState(0);
    const [numScreens, setNumScreens] = useState(0);
    const [appSet, setAppSet] = useState(new Set());

    const [processName, setProcessName] = useState(null);

    // const [screenElements, setScreenElements] = useState(initialScreenElements);

    const [currentSubmissionId, setCurrentSubmissionId] = useState(null);
    const [currentTaskName, setCurrentTaskName] = useState(null);

    const [currentProcessId, setCurrentProcessId] = useState("PROC-50");


    const [imageMap, setImageMap] = useState(new Map);
    const [loading, setLoading] = useState(false)

    const onConnect = (params) => setElements((els) => addEdge(params, els));
    const onElementsRemove = (elementsToRemove) =>
      setElements((els) => removeElements(elementsToRemove, els));
    
      // const onScreenElementsRemove = (elementsToRemove) =>
      // setScreenElements((els) => removeElements(elementsToRemove, els));
  

    const onSubmissionIdChange = (newId, taskName)=> {
      setCurrentSubmissionId(newId)
      setCurrentTaskName(taskName)
      loadSubmission(newId)

    }

    const onProcessIdChange = (newId, processName)=> {
      setCurrentProcessId(newId)
      setProcessName(processName)
    }


    const onLoad = (_reactFlowInstance) =>
      setReactFlowInstance(_reactFlowInstance);
  
    const onDragOver = (event) => {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';
    };
  

    
    const onElementClick = (event, element) => {
        event.preventDefault();
        setSelectedElement(element)
        console.log("Clicked in process disc")
    }

    const open = () =>{
      load()
      getImages()
    }

    const download = () =>{
    }

    const upload = () =>{
    }

    // const checkTimeSpent = ( value, key, map) =>{
    //   if (mostTimeSpent < value){
    //     setMostTimeSpent (value)
    //     setMostTimeSpentApp (key)
    //   }
    // } 

    const loadAppJSON = (content)=>{
            lastPosition = { x:400, y:50}
            const events = JSON.parse(content)
            console.log(content)
            var sourceElement = null;

            var elementBuffer = []
            var increment = 150  
            var totalTime = 0
            var mostTime = 0
            var mostApp = ''
            setAppHops(events.length)

            events.map(item => {
                var id = getId()
                var position = {x:lastPosition.x , y: lastPosition.y + increment}
                const type = "AppNode"
                
                totalTime = totalTime + item.timeSpent
                var value = appTimeMap.get(item.shortApp)
                if (value == null) {
                  appTimeMap.set(item.shortApp, item.timeSpent)
                  if (mostTime < item.timeSpent){
                    mostTime= item.timeSpent
                    mostApp = item.shortApp
                  }
                  console.log("setting map " + item.shortApp)

                }
                else{
                  value = value + item.timeSpent
                  appTimeMap.set(item.shortApp, value)
                }
                appSet.add(item.shortApp)
                const newNode = {
                  id: id,
                  type,
                  position,
                  style:nodeStyle, 
                  data: { appName:item.app, appShortName:item.shortApp, appType:item.appType, timeSpent:item.timeSpent}
                };
                // elementBuffer.add(newNode)
                  setAppElements((es) => es.concat(newNode));
                // console.log(newNode)
      
                if ( sourceElement != null)
                {
                  const edgeId = appFromElement + '-' + id
      
                  const newEdge = 
                  {
                    id: edgeId,
                    source: sourceElement,
                    style:{strokeWidth:3.0},
                    target: id,
                    type:'step',
                    arrowHeadType: 'arrow',
                  }
                  
                  // elementBuffer.add(newEdge)
                  setAppElements((es) => es.concat(newEdge));
                }
      
                sourceElement = newNode.id          
                lastPosition = position
              }
      
      
          );

          //   elementBuffer.map(item=>{

          //     setAppElements((es) =>{
          //       es.concat(item)
          //   });
          
          // });

          setAppFromElement(sourceElement)
          setTotalTime(totalTime)
          setAppSet(appSet)

          // console.log(appTimeMap)
          setMostTimeSpentApp(mostApp)    
          setMostTimeSpent(mostTime)    
          
        }


    const loadAppFlowModel = () =>{
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json'}
      }
  
      fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/newbot/files/apps.json' , requestOptions)
      .then (async response => {
        const data = await response.text();
        console.log(data)
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          return Promise.reject(error);
  
        }
        loadAppJSON(data);
      })

      .catch(error => {
        // alert(error)
        alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
      });



    }
    const loadModel = (content) => {
        
      clearElements(elements.slice(1))
      setSelectedElement(elements[0])
      setFromElement('1')
      lastPosition = { x:400, y:50}
      const events = JSON.parse(content)
      var sourceElement = '1'
      var index=0
      var increment = 200  
      var lastType=''

      events.map(item => {
          var id = getId()
          var skip = false
          var position = {x:lastPosition.x , y: lastPosition.y + increment}
          var name = item["py/object"]
          var ind1 = name.indexOf('.')
          var ind = name.lastIndexOf('Event')
          name = name.substring(ind1+1, ind)
          const type = getNodeType(name)
          // console.log(type)  
          var screenImage = ''
          var nodeType = type
          var screenAttributes = {}
          var attributes = {}
          if (type.startsWith('Key')  || type.startsWith('Text') || name == "HotKey" || name.startsWith("Key"))
          {
            // if (lastType=='Key')
            // skip = true
            // else {
            //   lastType = 'Key'
            // }
            skip = true
          }
          else  {
            skip = false
            lastType = type
          }
          if ( type == 'MouseNode' && item["command"] == 'release')
          {skip = true}
          if ( type == 'MouseNode' && item["command"] == 'scroll')
          {skip = true}
          if ( type == 'MouseNode' && item["command"] == 'move')
          {skip = true}
          if ( name == 'MouseDrag')
          {skip = true}
          if ( type == 'WaitNode')
          {skip = true}

          screenAttributes = {}


          if (!skip)
          {
            attributes = item
          if ( type == 'MouseNode')
          {
            if (item["command"] == 'press')
            {
              screenImage = 'screen' + index + '.png'
              nodeType = 'ScreenActivityNode'

              var screenImageData = imageMap.get(screenImage)
              var f = index.toString() + '.png'
              var clickImageData = imageMap.get(f)
              console.log("getting image for " +  f)

              if (item.screenAttributes == undefined || item.screenAttributes == null){
                screenAttributes = getFields("ScreenActivity")
                // attributes = screenAttributes 
              
              index = index + 1

              }
              else screenAttributes = item.screenAttributes
              increment = 700
            }
          }
          else{ 
            screenImage = ''
            increment = 200
          } 


          const appAttributes = getFields("ScreenActivity")
          const newNode = {
            id: id,
            type:nodeType,
            position,
            style:nodeStyle, 
            data: { label: name, "attributes":attributes, type:type, entity:entityName, screenImage:screenImage, screenImageData: screenImageData, clickImageData:clickImageData, screenAttributes:screenAttributes}
          };

          setElements((es) => es.concat(newNode));

          if ( sourceElement != null)
          {
            const edgeId = fromElement + '-' + id

            const newEdge = 
            {
              id: edgeId,
              source: sourceElement,
              style:{strokeWidth:3.0},
              target: id,
              type:'step',
              arrowHeadType: 'arrow',
            }
            
            setElements((es) => es.concat(newEdge));
          }

          sourceElement = newNode.id          
          lastPosition = position
        }
      


    });
    setFromElement(sourceElement)
    setNumScreens (index)

    // loadAppFlowModel();
    return true;

  }





    const load = () =>
    {
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json'}
      }
  
      fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/load/newbot' , requestOptions)
      .then (async response => {
        const data = await response.text();
        // console.log(data)
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          return Promise.reject(error);
  
        }
        loadModel(data)
        loadAppFlowModel();


      })

      .catch(error => {
        // alert(error)
        alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
      });
  
    }


    function blobToDataURL(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = _e => resolve(reader.result);
        reader.onerror = _e => reject(reader.error);
        reader.onabort = _e => reject(new Error("Read aborted"));
        reader.readAsDataURL(blob);
      });
    }

    const loadSubmission = (id) =>
    {
      setLoading(true)
      var appModelData = ""
      var url = `${process.env.REACT_APP_API_PREFIX}/storagemanagement/generateDownloadPresignedUrlListBySubmissionId/` ;
      const body = {submissionId: id}
      console.log(body)
      // const urls = apiPost(url, body )
      var urls
      var requestOptions = {
        method: 'POST',
        body:JSON.stringify(body),
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('TOKEN')}
      }
  
      fetch(url , requestOptions)
      .then (async response => {
        const data = await response.text();
        // console.log(data)
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          return Promise.reject(error);
  
        }
        urls = JSON.parse(data)
        if (urls.result == "failure") { alert("Nothing submited"); return }
        
        console.log(urls)
        var list = urls.data.preSignedUrList
  
        for (var index = 0; index < list.length; index ++ ){
          var fileName = list[index].fileBaseName
          var downloadURL = list[index].url
          var contentType = list[index].contentType
          // console.log("downloaded: " + JSON.stringify(list[index]))
          console.log(fileName)
          const options = {
            method: 'GET',
            // headers: { 'Content-Type': contentType}
          }
      
          await fetch(downloadURL, options)
          .then (async response => {
            console.log(downloadURL)
            var data 
            if (contentType == 'image/png')
            {
              // data = await response.arrayBuffer();
              data = await response.blob();
              data = await blobToDataURL(data)

            }
            else
              data = await response.text();

            if (!response.ok) 
            {
              const error = (data && data.message) || response.status;
              console.log(error)
              return Promise.reject(error);
      
            }

            console.log(fileName)
            
            if (fileName == 'apps.json')
            {
              console.log("Loading app json")
              console.log(data)
              loadAppJSON(data.slice())
            }
            else if (fileName.includes('.rec'))
            {
              appModelData = (data.slice())
            }
            else{
              imageMap.set(fileName, data)
              console.log("Its an image file: " + fileName)
            }
            
            // console.log("Got response:" + data)
          })
    
          .catch(error => {
            alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
            // alert(error)
          });

          if(appModelData != "")
          {
            console.log("Loading model")
            console.log(appModelData)
            loadModel(appModelData)
          }
        }
    
  
  
      })
  
      .catch(error => {
        // alert(error)
        alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
      })

      .finally()
      {
        // console.log(imageMap)
      
        waitFor(4000).then(()=>{
          setLoading(false)
  
        });
  
      }




    }

  const waitFor = (milliseconds) =>{
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }




    const getImages = () =>
    {
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json'}
      }
  
      fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/images/list/'+ entityName , requestOptions)
      .then (async response => {
        const data = await response.text();
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          return Promise.reject(error);
  
        }
        // console.log("Loaded: " + data)

        // Commenting out as ScreenFlow is not a tab anymore
        // loadImageModel(data)

      })

      .catch(error => {
        alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
        // alert(error)
      });
  
    }

    const clearElements = (elementsToRemove)=>
    {
      if (elementsToRemove == null) return
      if (elementsToRemove.length == 0){return}
      
      onElementsRemove(elementsToRemove)


    }


  //   const loadImageModel = (content) => {
        
  //     clearScreenElements(screenElements.slice(1))
  //     lastPosition = { x:250, y:50}
  //     const events = JSON.parse(content)

  //     var sourceElement = '1'

  //     events.map(item => {
  //       if(item.startsWith('screen')){
  //       var id = getId()
  //       var position = {x:lastPosition.x , y: lastPosition.y + 500}

  //       const type = "ScreenNode" 
        
  //       const newNode = {
  //         id: id,
  //         type,
  //         position,
  //         // style:nodeStyle, 
  //         data: { image:item, entity:entityName }
  //       };

  //       setScreenElements((es) => es.concat(newNode));

  //       if ( sourceElement != null)
  //       {
  //         const edgeId = fromElement + '-' + id

  //         const newEdge = 
  //         {
  //           id: edgeId,
  //           source: sourceElement,
  //           style:{edgeStyle},
  //           target: id,
  //           type:'step',
  //           arrowHeadType: 'arrow',
  //         }
          
  //         setScreenElements((es) => es.concat(newEdge));
  //       }

  //       sourceElement = newNode.id          
  //       lastPosition = position
  //     }

  //     });
  //   return true;

  // }




      const toolbar = ()  =>
      {
        return (
        <div className="toolbar">
        {/* <button className='toolbutton' onClick={open}>Load</button>
        <button className='toolbutton' onClick={record}>Launch Recorder</button> */}

        <button className='toolbutton' onClick={record}><img width='25' height='25'  src={recorder}></img></button>
        <button className='toolbutton' onClick={open}><img width='25' height='25'  src={loadimg}></img></button>
        <button className='toolbutton' onClick={upload}><img width='25' height='25'  src={cloudupload}></img></button>
        <button className='toolbutton' onClick={download}><img width='25' height='25'  src={clouddownload}></img></button>

        </div>
        );

      }
      
      const saveModel = (event) =>
      {
        // event.preventDefault();
        // save(model, 'process-model.json')
        // console.log('saved')
      
      }
      

      const callRefresh = ()=>{
        setLoading(true)
      }


      const record = () =>
      {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
      
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/bots/execute/recorder' , requestOptions)
        .catch(error => {
          // alert(error)
          alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
        });
      
      }



      return (

          <div className="processdiscovery">
              {/* {toolbar()} */}
              {/* <ProcessList setProcessName={setProcessName} onProcessIdChange = {onProcessIdChange}/> */}
              <PDTabs refresh={callRefresh} processId={currentProcessId} loading={loading} processId = {currentProcessId} processName = {processName} onProcessIdChange = {onProcessIdChange} currentTaskName = {currentTaskName} onSubmissionIdChange={onSubmissionIdChange} data = {elements} numScreens = {numScreens}  apps={appElements} appSet={appSet} totalTime = {totalTime} mostTimeSpent={mostTimeSpent} mostTimeSpentApp={mostTimeSpentApp} appHops={appHops}/>

          </div>

    );


  };

  
  // const endNode = () {
    
    // ***Removing the End node ******
    // const lastNode =    {
    //   id: '2',
    //   type: 'output',
    //   data: { label: 'End' },
    //   position: { x: 250, y: lastPosition.y + 100 },
    //   style: {
    //     background: 'gray',
    //     color: 'white',
    //     border: '1px solid #222138',
    //     width: 180,
    //   },
    // }

    // setElements((es) => es.concat(lastNode));


    // const lastEdgeId = getId()
    // const lastEdge = 
    // {
    //   id: lastEdgeId,
    //   source: sourceElement,
    //   target: toElement,
    //   type:'step',
    //   // animated: true,
    //   // type:'buttonedge',
    //   arrowHeadType: 'arrow',
    // }
    // setElements((es) => es.concat(lastEdge));

  // }


  export default ProcessDiscovery;